export default __webpack_public_path__ + "static/media/nvidia-logo.1d2bd101.png";